
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-start overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/7ca6d27263492c1cb75c8530c5828200.jpg"
          alt="Digital Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-8 py-32">
        <div className="max-w-7xl mx-auto">
          <div className="w-full lg:w-1/2">
            <h1 className="text-7xl font-extrabold text-white leading-tight mb-12">
              Secure Your<br />
              Digital Freedom<br />
              Today
            </h1>
            <p className="text-lg text-white/80 leading-relaxed mb-16 max-w-xl">
              Experience unrestricted internet access with military-grade encryption and lightning-fast connection speeds
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-24 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex items-end gap-8">
            <div className="bg-black/60 backdrop-blur-sm rounded-3xl p-8 w-80">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-white text-xl font-semibold mb-2 whitespace-nowrap">Bank-Level Encryption</h3>
              <p className="text-white/70 text-sm whitespace-nowrap">AES-256 bit protection</p>
            </div>

            <div className="bg-black/60 backdrop-blur-sm rounded-3xl p-8 w-80 transform translate-y-[-40px]">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className="ri-flashlight-line text-4xl text-white"></i>
              </div>
              <h3 className="text-white text-xl font-semibold mb-2 whitespace-nowrap">Ultra-Fast Servers</h3>
              <p className="text-white/70 text-sm whitespace-nowrap">Global network coverage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
